/** Order-related enums, mirrored from the BE order module. */

export enum ProductType {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  TOUR = 'TOUR',
  ESIM = 'ESIM',
}

export enum OrderStatus {
  NEW = 'NEW',
  CONFIRM = 'CONFIRM',
  CANCEL = 'CANCEL',
  HOLD = 'HOLD',
  FAIL = 'FAIL',
}

/** Payment status of an order. */
export enum PaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAIL = 'FAIL',
  CANCEL = 'CANCEL',
}

/** Booking hold / issue status as returned by the booking API. */
export enum BookingStatus {
  PENDING = 'PENDING',
  HOLD = 'HOLD',
  ACTIVE = 'ACTIVE',
  FAIL = 'FAIL',
  CANCEL = 'CANCEL',
}

export enum TicketStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAIL = 'FAIL',
  CANCEL = 'CANCEL',
  VOID = 'VOID',
}

export enum TicketType {
  TKT = 'TKT',
}

export enum ServiceStatus {
  CONFIRM = 'CONFIRM',
  FAIL = 'FAIL',
  PENDING = 'PENDING',
}

export enum ServiceType {
  SEAT = 'SEAT',
  BAGGAGE = 'BAGGAGE',
  SERVICE = 'SERVICE',
  CHECKIN = 'CHECKIN',
}

export enum TransactionStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAIL = 'FAIL',
  CANCEL = 'CANCEL',
}

export enum TransactionType {
  NEW_PAYMENT = 'NEW_PAYMENT',
  RE_PAYMENT = 'RE_PAYMENT',
}

export enum PaymentGateway {
  ONEPAY = 'ONEPAY',
  MOMO = 'MOMO',
  EXTERNAL = 'EXTERNAL',
  INTERNAL = 'INTERNAL',
}

export enum PaymentMethod {
  INTERNATIONAL = 'INTERNATIONAL',
  DOMESTIC = 'DOMESTIC',
  QR = 'QR',
  BNPL = 'BNPL',
  PAYNOW = 'PAYNOW',
  DIGITALWALLET = 'DIGITALWALLET',
  MOMO = 'MOMO',
  VNPAY = 'VNPAY',
  /** Company credit limit (TMS). */
  CREDIT_LIMIT = 'CREDIT_LIMIT',
}

export enum InvoiceStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending',
  Deleted = 'Deleted',
}

/** Landing page of each product — where checkout sends the user when there is no order to show. */
export const PRODUCT_HOME_PATHS: Record<ProductType, string> = {
  [ProductType.FLIGHT]: '/ve-may-bay',
  [ProductType.HOTEL]: '/hotels',
  [ProductType.ESIM]: '/esim-du-lich',
  [ProductType.TOUR]: '/tours',
}

/** Checkout page of each product; opened with `?orderCode=` to pay an existing order. */
export const PRODUCT_CHECKOUT_PATHS: Partial<Record<ProductType, string>> = {
  [ProductType.FLIGHT]: '/booking/flight/checkout',
  [ProductType.HOTEL]: '/booking/hotel',
  [ProductType.ESIM]: '/booking/esim',
}

/** Checkout URL to pay an existing order, or null when the product has no checkout page. */
export const getOrderCheckoutPath = (productType: string | undefined, orderCode: string) => {
  const path = PRODUCT_CHECKOUT_PATHS[productType as ProductType]
  return path ? `${path}?orderCode=${encodeURIComponent(orderCode)}` : null
}

/** Preview order: replaces a filled passport/document number, so the client can tell it was entered. */
export const PREVIEW_FILLED_VALUE = 'FILLED'
